import { BackendBaseModel, DateRangeSchema } from '@/utils';
import { z } from 'zod';
import { tagScopeType, tagType } from './tags';

const LocalTagBaseModel = BackendBaseModel.extend({
  type: tagType,
  name: z.string().min(1).max(16),
  organizationId: z.string().uuid(),
  sharedOrganizationIds: z.string().uuid().array(),
  isPubliclyViewable: z.boolean().optional(),
  startYear: z.number().int().nullable(),
  endYear: z.number().int().nullable(),
  scope: tagScopeType,
});

export const LocalTagsModel = LocalTagBaseModel.array();

/// ////////////////////////////////////////////
/// Schema
/// ////////////////////////////////////////////

export const LocalTagFormSchema = LocalTagBaseModel.pick({
  type: true,
  name: true,
  isPubliclyViewable: true,
}).extend({
  nestedSharedOrganizationIds: z.string().uuid().array().array(),
  organizationId: LocalTagBaseModel.shape.organizationId.array(),
  period: DateRangeSchema.nullish(),
});

export const LocalUpdateTagMutationParamsSchema = LocalTagFormSchema.extend({
  id: z.string().uuid(),
});
